<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                                <input matInput id="txtSiteRecebimento" #txtSiteRecebimento maxlength="10"
                                    formControlName="site_recebimento" class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Estratégia
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtDataEstrategia" #txtDataEstrategia maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000" formControlName="data_estrategia">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataEstrategia.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_estrategia)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Híbrido</mat-label>
                                <mat-select #txtHibrido formControlName="hibrido_rnc_linhagem" disableCenteringOption (selectionChange)="getListLoteDS($event)">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterHibrido($event.target.value)">
                                    <mat-option *ngFor="let item of listHibrido" [value]="item.name">{{ item.name |
                                        uppercase }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Safra</mat-label>
                                <mat-select #txtSafra formControlName="safra" disableCenteringOption
                                    [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" (selectionChange)="getListLoteDS($event)">

                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterSafra($event.target.value)">
                                    <mat-option *ngFor="let item of listSafra" [value]="item.name" >
                                        {{ item.name | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
                                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                                floatLabel="{{ formFieldFloatLabel }}">
                                <mat-label class="InputLabelColor">Lote DS</mat-label>
                                <mat-select #txtLoteDs formControlName="lote_ds" disableCenteringOption
                                    [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" multiple (selectionChange)="onChangeLotDS($event)">
                                    <mat-option *ngFor="let item of listLoteDS" [value]="item.lote_ds">
                                        {{ item.lote_ds | uppercase }}
                                    </mat-option>
                                </mat-select>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_ds)}}</mat-error>
                                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Volume Analisado (kgs)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtVolumeAnalisado" #txtVolumeAnalisado maxlength="10"
                                    formControlName="volume_analisado" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.volume_analisado)}}
                                </mat-error>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>


                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>